var url = "89e1dd9a4dfbfe90479f6c51c61dfe3d.png";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;